import React, { FC } from 'react';

import { Button as OrbButton } from '@yandex-360/orb-components/dist/components/Button';

import { SvgImage } from '../../../../shared/components';
import { parentFrameCommunicator } from '../../../../shared/features/parent-frame-communicator';
import { i18n } from '../../../../shared/helpers/i18n';
import { OutgoingEvents } from '../../iframe-sagas/types';
import styles from './styles.css';

const backIcon = <SvgImage imageName="arrowLeftOutlineSm" />;

export const MeetingBackButton: FC = () => {
    return (
        <OrbButton
            view="neutral"
            size="md"
            className={styles.meetingBackButton}
            onPress={() => {
                parentFrameCommunicator.sendMessage('messenger', {
                    event: OutgoingEvents.BACK_BUTTON_CLICK,
                });
            }}
            icon={backIcon}
            aria-label={i18n('common', 'back')}
        />
    );
};
